import React from 'react';
import './DashboardOverview.css';

export default function DashboardOverview({ items, children, embedded = false, actionsLabel = '' }) {
  return (
    <section className={`dashboard-overview${embedded ? ' dashboard-overview--embedded' : ''}`} aria-label="Daily overview and quick actions">
      {!embedded && <div className="dashboard-overview__heading">
        <span className="dashboard-overview__eyebrow">Start your day</span>
        <h2>Overview</h2>
        <p>Check updates and choose an action.</p>
      </div>}
      {items.length > 0 && <div className="dashboard-overview__metrics">
        {items.map(item => {
          const Element = item.target ? 'a' : 'div';
          return (
          <Element className="dashboard-overview__metric" key={item.label}
            href={item.target ? `#${item.target}` : undefined}
            onClick={item.target ? (event) => {
              const section = document.getElementById(item.target);
              if (!section) return;
              event.preventDefault();
              section.focus({ preventScroll: true });
              section.scrollIntoView({ behavior: 'auto', block: 'start' });
            } : undefined}>
            <i className={`bi bi-${item.icon}`} aria-hidden="true" />
            <div><strong>{item.value}</strong><span>{item.label}</span></div>
          </Element>
        );})}
      </div>}
      {actionsLabel && <h2 className="dashboard-overview__actions-label">{actionsLabel}</h2>}
      <div className={`dashboard-overview__actions${actionsLabel ? ' dashboard-overview__actions--labelled' : ''}`}>{children}</div>
    </section>
  );
}
